import { COMMONS } from 'src/app/core/utils/commons.constants';

export const HISTORY_PERSONAL_COMPLETE_CONSTANTS = {
  ...COMMONS,
  heading: 'Antecedentes Personales [Ginecología]',
  tooltip: 'FUM: Fecha última menstruación, FUP: Fecha último parto, FUC: Fecha última citología',
  sexLife: 'Vida sexual activa',
  biopsy: 'Biopsia',
  hormonalTherapy: 'Terápia hormonal',
  colposcopy: 'Colposcopía',
  mammography: 'Mamografía',
  menarche: 'Menarquía - Edad',
  menopause: 'Menopausia - Edad',
  cycle: 'Ciclos',
  gestation: 'Gesta',
  birth: 'Partos',
  misbirth: 'Abortos',
  caesarean: 'Cesareas',
  livingChildren: 'Hijos vivos',
  lastMenstruation: 'FUM',
  lastBirth: 'FUP',
  lastCytology: 'FUC',
  familyMethod: 'Método familiar',
  allergy: 'Alergia',
  datePlaceholder: 'dd-mm-yyyy'
};
